import ReactECharts from 'echarts-for-react'
import {useMemo} from 'react'
import {SystemRole} from '../../Constants'
import {useAppConfig} from '../../context/app/AppContext'
import {useUserHospital} from '../../context/hospital/UserHospitalContext'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useAuth} from '../authentication/AuthProvider'
import {getClientId} from '../authentication/AuthUtils'
import {useListActiveDeviceByGender} from './query-keys/ChartQueryManager'

const PieChart = () => {
    //#region Context
    const {user} = useAuth()
    const {currentHospital} = useUserHospital()
    const {userRole} = useAppConfig()
    //#endregion

    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion
    //#region Query
    const {data} = useListActiveDeviceByGender(
        user?.id,
        userRole === SystemRole.USER_WITH_ROLE ? currentHospital?.id : null,
        !!user?.id && !!getClientId(),
    )
    //#endregion

    //#region Memo
    const option = useMemo(
        () => ({
            legend: {
                top: 'bottom',
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        show: true,
                        title: translateCommons('Save as image'),
                    },
                },
            },
            title: [
                {
                    left: 'center',
                    text: translateCommons('Device Active by Gender'),
                    subtext: translateCommons(
                        'Showing the number of devices active by Gender',
                    ),
                },
            ],
            tooltip: {
                show: true,
            },
            series: [
                {
                    type: 'pie',
                    radius: [20, 140],
                    center: ['50%', '50%'],
                    innerHeight: '80vh',
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 10,
                    },
                    data: [
                        {
                            value:
                                !!data?.male && data.male > 0 ? data.male : 0,
                            name: translateCommons('Male'),
                        },
                        {
                            value:
                                !!data?.female && data?.female > 0
                                    ? data.female
                                    : 0,
                            name: translateCommons('Female'),
                        },
                        {
                            value:
                                !!data?.indeterminate && data?.indeterminate > 0
                                    ? data.indeterminate
                                    : 0,
                            name: translateCommons('Indeterminate'),
                        },
                        {
                            value:
                                !!data?.unknown && data?.unknown > 0
                                    ? data.unknown
                                    : 0,
                            name: translateCommons('Unknown'),
                        },
                    ],
                },
            ],
        }),
        [data, translateCommons],
    )
    //#endregion

    return (
        <div className="h-full w-full p-3 border-1 border-gray-100 border-round-lg">
            <ReactECharts
                style={{
                    height: '100%',
                    width: '100%',
                    zIndex: '0',
                    position: 'relative',
                }}
                lazyUpdate
                option={option}
            />
        </div>
    )
}

export default PieChart
